module.exports = __webpack_public_path__ + "static/agnitio-logo.7d4ff2f9.svg";